import React, { useEffect, useState } from "react"
import { Box, FormGroup, FormControlLabel, Switch } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import { useDispatch, useSelector } from "react-redux"
import { searchHighlightFilter } from "../../actions/highlightActions"

const useStyles = makeStyles((theme) => ({
	root: {
		flex: 9,
		padding: "16px 23px",
		display: "flex",
		alignItems: "center",
		borderRight: `solid 1px ${theme.palette.grey.D400}`,
		"& .MuiFormControlLabel-label": {
			fontSize: theme.typography.fontSize,
			fontWeight: theme.typography.fontWeightRegular,
		},
	},
}))

const BlueSwitch = withStyles((theme) => ({
	switchBase: {
		color: theme.palette.common.white,
		"&$checked": {
			color: theme.palette.primary.dark,
		},
		"&$checked + $track": {
			backgroundColor: theme.palette.primary.dark,
		},
	},
	checked: {},
	track: {},
}))(Switch)

export default function NativeViewSwitch() {
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles(theme)
	const dispatch = useDispatch()
	const highlightFilter = useSelector((state) => state.highlightFilter.search)

	const handleChange = (event) => {
		const filterData = { ...highlightFilter }
		filterData["nativeView"] = !filterData.nativeView
		dispatch(searchHighlightFilter(filterData))
	}

	return (
		<Box mr={2}>
			<FormGroup row className={classes.root}>
				<FormControlLabel
					control={<BlueSwitch checked={!highlightFilter?.nativeView} onChange={handleChange} name="nativeView" />}
					label={t("nativeViewer.nativeView")}
					labelPlacement="start"
				/>
			</FormGroup>
		</Box>
	)
}
